export default __webpack_public_path__ + "static/media/logo-mentor.bbca7ed7.png";